import { PLAN_LABEL, PLAN_ORDER, PLAN_SUMMARY } from "@/utils/plans";
import type { SchoolPlan } from "@/types";

interface PlanPickerProps {
  value: SchoolPlan;
  onChange: (plan: SchoolPlan) => void;
  disabled?: boolean;
}

/** Choix du forfait (demande publique, ouverture et configuration d'une école). */
export default function PlanPicker({
  value,
  onChange,
  disabled,
}: PlanPickerProps) {
  return (
    <div
      role="radiogroup"
      aria-label="Forfait"
      className="grid grid-cols-1 gap-2 sm:grid-cols-3"
    >
      {PLAN_ORDER.map((plan) => {
        const checked = plan === value;
        return (
          <button
            key={plan}
            type="button"
            role="radio"
            aria-checked={checked}
            disabled={disabled}
            onClick={() => onChange(plan)}
            className={`press rounded-md border px-3 py-2.5 text-left transition-colors ${
              disabled ? "cursor-default" : "cursor-pointer"
            } ${
              checked
                ? "border-primary-300 bg-primary-50"
                : "border-background-300 bg-background-50 hover:bg-background-100"
            }`}
          >
            <span className="flex items-center gap-2 text-sm font-medium text-foreground-900">
              <i
                className={
                  checked
                    ? "ri-radio-button-fill text-primary-700"
                    : "ri-checkbox-blank-circle-line text-foreground-400"
                }
                aria-hidden="true"
              ></i>
              {PLAN_LABEL[plan]}
            </span>
            <span className="mt-1 block text-xs leading-snug text-foreground-500">
              {PLAN_SUMMARY[plan]}
            </span>
          </button>
        );
      })}
    </div>
  );
}
